import React from 'react';
import styles from './VerticalSeparator.module.css';

const VerticalSeparator = ({ customClasses }) => (
  <div
    className={`${styles.verticalSeparator} ${customClasses || 'header-item'}`}
  />
);

export default VerticalSeparator;
